import styled from 'styled-components';
import { v2Breakpoints } from './styles/tokens';

export const FormLayout = styled.div`
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  padding: 4px 10px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 4px 7px;
  }
`;
